import { CorporationDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";
import { ContactToValidateBody } from "@bcasmart/doxecure-commons/doxecureTypes";
import { Nullable } from "foundation-ts/types";

import { NewPersonFormValues } from "@/components/ContactForm/ContactForm";

export type ModalWindowSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full' ;

export interface ModalWindowState {
    title?: Nullable<string> ;
    message? : Nullable<string> ;
    size?:ModalWindowSize ;
    onClose: () => Promise<void> ;
}

export interface ModalAction {
    value:any ;
    label:string ;
    onSelect:(selectedValue:any) => Promise<void>
}

export interface AsyncActionModalState extends ModalWindowState {
    element: Nullable<JSX.Element> ;
    isOpen: boolean ;
    confirm?: Nullable<string> ;
    cancel?: Nullable<string> ;
    disabledConfirm?: boolean ;
    onAccept: () => void ;
}

export const DefaultAsyncActionModalState:AsyncActionModalState = {
    element: null,
    isOpen: false,
    onAccept: async () => {},
    onClose: async () => {},
} ;


export interface AsyncConfirmModalState extends ModalWindowState {
    onAccept: () => Promise<void>;
    confirm?:Nullable<string>;
    cancel?:Nullable<string>;
    actions?:Nullable<ModalAction[]>;
}

export const DefaultAsyncConfirmModalState: AsyncConfirmModalState = {
    title: undefined,
    message: undefined,
    confirm: undefined,
    cancel: undefined,
    onAccept: async () => {},
    onClose: async () => {}
} ;

export interface AsyncLinkUserModalState extends ModalWindowState {
    items: Nullable<CorporationDto[]>;
    isOpen: boolean;
    onAccept: (corporation: Nullable<CorporationDto>) => Promise<void>;
}

export const DefaultAsyncLinkUserModalState:AsyncLinkUserModalState = {
    items: null,
    isOpen: false,
    onAccept: async () => {},
    onClose: async () => {},
} ;

export interface AsyncRefuseModalState extends ModalWindowState {
    isOpen: boolean;
    defaultReason?: string;
    onAccept: (reason: string) => void;
}

export const DefaultAsyncRefuseModalState: AsyncRefuseModalState = {
    isOpen: false,
    defaultReason: "",
    onAccept: (_reason: string) => {},
    onClose: async () => {},
} ;

export interface AsyncSelectItem {
    label: string;
    labelDesc?: string;
    complement1?: string;
    complement2?: string;
    color: string;
    bg: string;
    hover: {
        color: string;
        bg: string; 
    } ;
    selected: {
        color: string;
        bg: string;
    }
}

export interface AsyncSelectModalState extends ModalWindowState {
    items: Nullable<Array<AsyncSelectItem|string>> ;
    onSelect: (index:number) => Promise<void>;
}

export const DefaultAsyncSelectModalState:AsyncSelectModalState = {
    items: null,
    onClose: async () => {},
    onSelect: async (_index:number) => {},
} ;

export interface AsyncValidateContactInfosModalState extends ModalWindowState {
    isOpen: boolean;
    senderName?: string;
    contactInfos?: ContactToValidateBody;
    onAccept: (updatedInfos: NewPersonFormValues, badRecipient?: boolean, notusingPhonenumber?: boolean) => Promise<void>;
};

export const DefaultAsyncValidateContactInfosModalState: AsyncValidateContactInfosModalState = {
    isOpen: false,
    senderName: undefined,
    contactInfos: undefined,
    onAccept: async () => {},
    onClose: async () => {},
};

export interface ConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAccept?: () => void;
    headerText?: string;
    bodyText?: string;
    data?: any;
}

export const DefaultConfirmModalState: ConfirmModalProps = {
    isOpen: false,
    bodyText: undefined,
    onClose: () => {}
} ;

export interface WaitingModalProps {
    isOpen: boolean;
    message?: Nullable<string>;
    onClose: () => void;
} ;

export const DefaultWaitingModalState: WaitingModalProps = {
    isOpen: false,
    onClose: () => {}
}